module.exports = __webpack_public_path__ + "img/GB-NIR.7aabc790.svg";